import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PageContent.AuditReportStatusIndicator', {
    auditReportPendingText: 'The audit report is being generated for you.{br}Please check again later.',
    auditReportGenerationError: 'Generating the audit report has failed.',
    auditReportConnectionError: 'Loading the audit report for preview has failed.',
});
